import React, {createContext, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useMatch} from 'react-router-dom';
import {config, dynamicConfig} from '../init/config';

interface LocaleContext {
    readonly language: string;
    readonly country: string;
}

export const LocaleContext = createContext<LocaleContext>({
    language: config.DLS_FALLBACK_LANGUAGE,
    country: config.DLS_FALLBACK_COUNTRY
});

const LANGUAGE_PATH = '/:country/:language/*';

const LocaleContextProvider: React.FC = (props) => {
    const pathParams = useMatch(LANGUAGE_PATH)?.params;
    const {i18n} = useTranslation();

    let country = pathParams?.country ?? config.DLS_FALLBACK_COUNTRY;
    let language = pathParams?.language ?? config.DLS_FALLBACK_LANGUAGE;

    if (dynamicConfig.SWAP_COUNTRY_LANGUAGE_ACTIVE && (language !== country)) {
        language = pathParams?.country ?? config.DLS_FALLBACK_LANGUAGE;
        country = pathParams?.language ?? config.DLS_FALLBACK_COUNTRY;
    }

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [pathParams]);

    return (
        <LocaleContext.Provider
            value={{
                language: language,
                country: country
            }}
        >
            {props.children}
        </LocaleContext.Provider>
    );
};

export default LocaleContextProvider;
